import '../css/Carregamento.css';

const Carregamento = () => {
    return (
        <div className="icon-carregamento">
        </div>
    )
}

export default Carregamento;